/** The value contract: a 24h time of day, whatever the field shows. The same as `TIME_FORMAT`. */
export const TIME_VALUE_FORMAT = 'HH:mm';

/** Minutes between the listed times when no explicit `options` are given. */
export const DEFAULT_INTERVAL = 15;

export const MINUTES_PER_DAY = 24 * 60;

/**
 * What the field accepts, case-insensitively and after trimming:
 * - `H:m` / `HH:mm` — `7:5`, `15:42`;
 * - bare digits — `9` and `15` are whole hours, `920` is 9:20, `1530` is 15:30;
 * - either, followed by an optional am/pm suffix — `3p`, `3:20 pm`, `3:20PM`, `3:20 p.m.`.
 */
export const TIME_INPUT_PATTERN = /^(?:(\d{1,2}):(\d{1,2})|(\d{1,4}))\s*(?:([ap])\.?\s*(?:m\.?)?)?$/i;
